'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _styledComponents=require('styled-components'),_styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var createStyledComponent=function(element,styleTemplate){return(0,_styledComponents2.default)(element).withConfig({displayName:'createStyledComponent'})(['',';'],styleTemplate)};exports.default=createStyledComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/styles/createStyledComponent.js
// module id = 560
// module chunks = 162